// extracted by mini-css-extract-plugin
module.exports = {"PageTransitionAnimator":"styles_PageTransitionAnimator__1TWV1","slideUp":"styles_slideUp__h9-x8"};